import { RawMessage } from 'api/interfaces/rawMessage';
import moment, { Moment } from 'moment';

export interface SummaryReportQuery {
  readonly from_time: Moment;
  readonly to_time: Moment;
  readonly assetType: '';
}

export interface SummaryReportResponse {
  readonly Records: RawMessage[];
  readonly Total: number;
}

export const fixTagToExecutionKey = (tag: string): keyof Execution | undefined => {
  const entry = Object.entries(fixMap).find(
    ([, fixTag]: [string, string]): boolean => fixTag === tag
  );
  return entry ? (entry[0] as keyof Execution) : undefined;
};

export const executionKeyToFixTag = (key: keyof Execution): string | undefined => {
  const tag = fixMap[key];
  return tag !== '' ? tag : undefined;
};

export const fixMap: Record<keyof Execution, string> = {
  id: '',
  transactionTime: '60',
  clientOrderId: '11',
  symbol: '55',
  side: '54',
  cumQty: '14',
  avgPx: '6',
  ordStatus: '39',
  execType: '150',
  account: '1',
  handlingInstructions: '21',
  orderQuantity: '38',
  orderType: '40',
  price: '44',
  senderCompId: '49',
  sendingTime: '52',
  targetCompId: '56',
  timeInForce: '59',
  onBehalfOfCompId: '115',
  venue: '128',
  securityType: '167',
  raw: '',
};

export interface Execution {
  readonly id: string;
  readonly transactionTime: Date;
  readonly clientOrderId: string;
  readonly symbol: string;
  readonly side: string;
  readonly cumQty: number;
  readonly avgPx: number;
  readonly ordStatus: string;
  readonly execType: string;
  readonly account: string;
  readonly handlingInstructions: string;
  readonly orderQuantity: number;
  readonly orderType: string;
  readonly price: number;
  readonly senderCompId: string;
  readonly targetCompId: string;
  readonly sendingTime: string;
  readonly timeInForce: string;
  readonly onBehalfOfCompId: string;
  readonly venue: string;
  readonly securityType: string;
  readonly raw: RawMessage;
}

export class Execution {
  public static fromRawMessage(rawMessage: RawMessage): Execution {
    const mappedFixTags = new Set(
      Object.values(fixMap).filter((tag: string): boolean => tag !== '')
    );

    const execution = Object.fromEntries(
      Object.entries(fixMap)
        .filter(([key]: [string, string]): boolean => key !== 'id' && key !== 'raw')
        .map(([key, tagNumber]: [string, string]): [keyof Execution, any] => {
          if (key === 'transactionTime') {
            return [
              key as keyof Execution,
              moment.utc(rawMessage[tagNumber], 'YYYY-MM-DDTHH:mm:ss.SSS').local(),
            ];
          }

          return [key as keyof Execution, rawMessage[tagNumber]];
        })
    ) as Execution;

    const extraFixTags = Object.fromEntries(
      Object.entries(rawMessage).filter(
        ([key]: [string, unknown]): boolean => !mappedFixTags.has(key) && key !== 'idlingomsg'
      )
    );

    return {
      ...execution,
      ...extraFixTags,
      id: String(rawMessage.idlingomsg),
      raw: rawMessage,
    };
  }
}
